import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import './App.css';
import Home from './pages/Home';
import { AuthProvider } from './contextauth/AuthContext';
import AdminDashboard from './components/AdminDashboard';
import Login from './components/Login';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Navbar /> {/* Doit être placé en dehors de <Routes> */}
        <div className="app-container">
        <Routes >
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
        </Routes>
        </div>

        <Footer /> {/* Doit être placé en dehors de <Routes> */}
      </Router>
    </AuthProvider>
  );
}

export default App;
